export const BYTES_PER_MEGABYTE = 1024 * 1024
export const BYTES_PER_GIGABYTE = 1024 ** 3

export const formatFileSize = (bytes?: number): string => {
  if (!bytes || bytes <= 0) return ""
  const megabytes = bytes / BYTES_PER_MEGABYTE
  if (megabytes >= 1024) {
    return `${(megabytes / 1024).toFixed(1)} GB`
  }
  return `${Math.round(megabytes)} MB`
}

export const formatStorageGb = (gigabytes: number): string => {
  const rounded = Math.round(gigabytes * 100) / 100
  return String(rounded > 0 && rounded < 0.01 ? 0.01 : rounded)
}
